import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal } from 'react-bootstrap';
import { TRACK_CLICK_UNITS_TABLE_CALL } from '../../../../../../../src/web/utils/dataLayer';
import { FacilityInfo } from '../../../../../../../src/web/components';
import { Amenities, Price, Size } from '../..';
import CurrentPageContext from '../../../../../../contexts/CurrentPageContext';
import Button from '../../../../../../../modules/react/components/stateless/Button';
import Phone from '../../../../../stateless/Phone';
import styles from '../Actions.scss';

export default class Call extends React.Component {
  static propTypes = {
    facility: PropTypes.shape({
      phone: PropTypes.string.isRequired,
      directPhone: PropTypes.string,
    }).isRequired,
    text: PropTypes.string.isRequired,
    useTel: PropTypes.bool,
  };

  static defaultProps = {
    useTel: false,
  };

  static contextType = CurrentPageContext;

  state = {
    showModal: false,
  };

  handleClose = () => this.setState({ showModal: false });

  handleClick = () => {
    const { useTel, facility } = this.props;
    // If we're told to, attempt to call the facility directly
    if (useTel) {
      const { phone: phoneNumber } = facility;
      window.location = `tel:${phoneNumber.replace(/[^\d]+/ig, '')}`;
      return true;
    }

    return this.setState({ showModal: true });
  };

  renderPhone() {
    const { secondaryColorClass } = this.context;
    const { facility: { phone: phoneNumber, directPhone } } = this.props;

    if (directPhone) {
      return (
        <div>
          <div className={styles.subHeading}>
            New Rentals:
            {' '}
            <Phone number={phoneNumber} />
          </div>
          <div className={styles.subHeading}>
            Current Customers:
            {' '}
            <Phone number={directPhone} />
          </div>
        </div>
      );
    }

    return <Phone number={phoneNumber} className={`${styles.blurb} ${secondaryColorClass}`} element="div" />;
  }

  renderModal() {
    const {
      primaryColorClass,
      secondaryColorBackgroundClass,
      primaryColorBackgroundHoverClass,
      buttonStyleClass,
    } = this.context;
    const { facility } = this.props;
    const overrideProps = { ...this.props, isModal: true };
    return (
      <Modal
        show
        onHide={this.handleClose}
        className={styles.callModal}
      >
        <Modal.Header closeButton>
          <div className={`${styles.title} ${primaryColorClass}`}>Please Call</div>
        </Modal.Header>

        <Modal.Body>
          <div className={styles.blurb}>
            <p>
              Due to limited availability, please call in order to reserve a
              similar unit.
            </p>
          </div>
          <div className={styles.subHeading}>Selected Unit</div>
          <Row className={styles.descriptionWell}>
            <Col xs={3}>
              <Size {...overrideProps} />
            </Col>
            <Col xs={7}>
              <Amenities {...overrideProps} />
            </Col>
            <Col xs={2} className={`text-end ${styles.strong}`}>
              <Price {...overrideProps} />
            </Col>
          </Row>

          <FacilityInfo facility={facility} showPhone={false} />

          {this.renderPhone()}
        </Modal.Body>

        <Modal.Footer>
          <Button
            onClick={this.handleClose}
            variant="primary"
            className={`${secondaryColorBackgroundClass} ${primaryColorBackgroundHoverClass} ${buttonStyleClass}`}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { showModal } = this.state;
    const { text, isUnitGroupExpanded, styleCallUG } = this.props;
    const {
      secondaryColorBackgroundClass,
      primaryColorBackgroundHoverClass,
      buttonStyleClass,
    } = this.context;
    return (
      <>
        { showModal && this.renderModal() }
        <Button
          block
          variant="primary"
          onClick={this.handleClick}
          data-event={'units-table-call'}
          className={`${secondaryColorBackgroundClass} ${primaryColorBackgroundHoverClass} ${buttonStyleClass} ${!isUnitGroupExpanded ? 'action-call' : styleCallUG}`}
          {...TRACK_CLICK_UNITS_TABLE_CALL}
        >
          {text}
        </Button>
      </>
    );
  }
}
